import { FaComments } from "react-icons/fa";
import SquareBox from "./SquareBox";
import { ImUsers } from 'react-icons/im'

export default function Boxcontainer() {
    return (
        <>
            {/* Top Card */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-16 select-none">
                <SquareBox
                    text={"Total Users"}
                    className={
                        "flex items-center justify-center bg-gradient-to-b from-blue-200 to-blue-100  px-5  rounded-lg shadow-xl py-10 "
                    }
                    iconContainerStyle={" rounded-full p-4 bg-blue-500"}
                    value={0}
                    Icon={ImUsers}
                    iconStyle={"h-9 w-9 text-white"}
                />
                <SquareBox
                    text={"Total Comments"}
                    className={
                        "flex items-center justify-center bg-gradient-to-b from-blue-200 to-blue-100  px-5  rounded-lg shadow-xl py-10 "
                    }
                    iconContainerStyle={" rounded-full p-4 bg-blue-500"}
                    value={0}
                    Icon={FaComments}
                    iconStyle={"h-9 w-9 text-white"}
                />
                
            </div>
        </>
    )
}